var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconMirrorVertical = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "6E9258F5-9FC3-4750-86BB-BB0B464D6812")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/sketch/flip/idle"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8F8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 12.250000) rotate(90.000000) translate(-12.000000, -12.250000) translate(1.000000, 4.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8596802,14.8032379 C21.858841,14.8032379 21.858841,14.8032379 21.8596802,14.8032379 L14.0672302,0.594848633 C13.8654785,0.228271484 13.4804382,0 13.0625,0 C12.4308929,0 11.9166107,0.514282227 11.9166107,1.14588929 L11.9166107,15.3541107 C11.9166107,15.9857178 12.4308929,16.5 13.0625,16.5 L20.8541107,16.5 C21.4857178,16.5 22,15.9857178 22,15.3541107 C22,15.1625977 21.9514923,14.9719238 21.8596802,14.8032379 Z",
    id: "Path",
    fill: "#535878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01248771,15.2940704 C1.0044224,15.3130588 1,15.3341678 1,15.3541107 C1,15.433433 1.06656698,15.5 1.14588929,15.5 L8.9375,15.5 C9.01682232,15.5 9.08338929,15.433433 9.08338929,15.3541107 L9.08338929,1.14588929 C9.08338929,1.06656698 9.01682232,1 8.9375,1 C8.88467892,1 8.83506276,1.02938619 8.80958446,1.07567714 L1.01248771,15.2940704 Z",
    id: "Path",
    stroke: "#535878",
    strokeWidth: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMirrorVertical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-mirror-vertical.34a35f2f.svg";
export { ForwardRef as ReactComponent };